// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_dq-0";
export var actionModalContentContainer = "_dq-1";
export var createTagButton = "_dq-2";
export var footerContainer = "_dq-7";
export var fullWidthDivider = "_dq-3";
export var hasCreateTagButton = "_dq-4";
export var noCreateTagButton = "_dq-5";
export var tagsContainer = "_dq-6";
export var tagsModalContentContainer = "_dq-8";